export enum EnumTpSituacaoIntegracao {
    Invalido = 0,
    IntegracaoDesabilitada = 1,
    IntegracaoHabilitada = 2,
    IntegracaoNaoAutorizada = 3,
    RedirecionamentoLogin = 3,
}